import { Stack, Text } from "@assetwatch/ui";

/**
 * The page's content. Build it out from here with @assetwatch/ui components.
 * As the page grows, its other files live next to this one: api.ts (its own
 * ML API endpoint), queries.ts, lib.ts, fixtures.ts and tests.
 */
export function ExamplePageScreen() {
  return (
    <Stack gap={8}>
      <Text>This is the example page.</Text>
      <Text size="sm" tone="subtle">
        Everything it needs is in one folder, src/pages/example-page/. Copy the
        folder to make a new page.
      </Text>
    </Stack>
  );
}
